import { format } from 'date-fns';

interface Params<T extends Record<string, unknown>, K = keyof T> {
  records: T[];
  attribute: K;
}

interface Result<T> {
  [key: string]: T[];
}

export const groupRecordsByDay = <T extends Record<string, unknown>>({
  records,
  attribute,
}: Params<T>): Result<T> => {
  return records.reduce<Result<T>>((acc, curr) => {
    if (typeof curr[attribute] !== 'string') return {};

    const date_string = curr[attribute] as string;

    const date = new Date(date_string);

    const day_string = format(date, 'yyyy/MM/dd');

    return {
      ...acc,
      [day_string]: [...(acc[day_string] || []), curr],
    };
  }, {});
};
